function forceMassyPricing() {
  if (typeof Massy === "undefined") return;

  const customerTags = (window.customerTags || []).map(t => t.toLowerCase());

  if (!customerTags.includes("retailer")) return;

  document.querySelectorAll('.main-price').forEach(el => {
    const variantId = el.getAttribute('data-variant-id');
    if (!variantId) return;

    Massy.getPrice(variantId, 1)
      .then(price => {
        if (price) {
          el.innerHTML = `$${parseFloat(price).toFixed(2)}`;
          console.log("Massy applied:", price);
        } else {
          console.log("No Massy price returned");
        }
      })
      .catch(err => console.log('Massy error:', err));
  });
}

function startMassyWatcher() {
  let tries = 0;

  const interval = setInterval(() => {
    if (typeof Massy !== "undefined") {
      forceMassyPricing();
    }

    tries++;
    if (tries > 20) clearInterval(interval);
  }, 400);
}

document.addEventListener("DOMContentLoaded", startMassyWatcher);
window.addEventListener("load", startMassyWatcher);

async function addAllQuickOrder() {
  const inputs = document.querySelectorAll('.qo-qty input');
  const items = [];

  for (const input of inputs) {
    const qty = parseInt(input.value || 0, 10);
    const id = input.dataset.variantId;
    if (qty > 0 && id) {
      let price = null;
      if (typeof Massy !== "undefined" && typeof Massy.getPrice === "function") {
        try { price = await Massy.getPrice(id, 1); } catch (e) {}
      }
      items.push({
        id: id,
        quantity: qty,
        properties: { _wholesale_price: price }
      });
    }
  }

  if (!items.length) {
    alert('Please enter quantities');
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(() => { window.location.href = '/cart'; })
  .catch(err => { console.error('Cart error:', err); });
}